// Audioralis recently-viewed: records PDP visits in localStorage and renders
// mini cards from /products/<handle>.js. No apps, no server state.
(function () {
  var KEY = 'aud-recent';
  var sections = document.querySelectorAll('.aud-recent');
  if (!sections.length) return;

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, 12))); } catch (e) {}
  }

  var current = sections[0].getAttribute('data-current-handle');
  if (current) {
    var list = read().filter(function (h) { return h !== current; });
    list.unshift(current);
    write(list);
  }

  function money(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  sections.forEach(function (sec) {
    var limit = parseInt(sec.getAttribute('data-limit'), 10) || 4;
    var grid = sec.querySelector('.aud-recent__grid');
    var handles = read().filter(function (h) { return h !== current; }).slice(0, limit);
    if (handles.length < 2) return;
    Promise.all(
      handles.map(function (h) {
        return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })
    ).then(function (products) {
      var ok = products.filter(Boolean);
      if (ok.length < 2) return;
      ok.forEach(function (p) {
        var a = document.createElement('a');
        a.className = 'aud-mini-card';
        a.href = '/products/' + p.handle;
        var img = p.featured_image ? '<div class="aud-mini-card__media"><img src="' + p.featured_image + '&width=360" loading="lazy" alt=""></div>' : '<div class="aud-mini-card__media aud-mini-card__media--empty"></div>';
        a.innerHTML = img + '<div class="aud-mini-card__info"><span class="aud-mini-card__vendor">' + (p.vendor || '') + '</span><span class="aud-mini-card__title">' + p.title + '</span><span class="aud-mini-card__price">' + money(p.price) + '</span></div>';
        grid.appendChild(a);
      });
      sec.hidden = false;
    });
  });
})();
